<template>
  <BaseFormFieldLayout
    :id="id"
    :label="label"
    :note="note"
    :error-message="errorMessage"
    :field-class="fieldClass"
  >
    <input
      v-bind="$attrs"
      :id="id"
      :value="model"
      name="email"
      class="form-control"
      :class="{ 'is-invalid': !!errorMessage }"
      @input="onInput"
      @blur="onBlur"
    />
  </BaseFormFieldLayout>
</template>

<script lang="ts" setup>
defineOptions({ inheritAttrs: false })

const model = defineModel<string | null>()

withDefaults(
  defineProps<{
    id: string
    label?: string
    note?: string
    errorMessage?: string
    fieldClass?: string
  }>(),
  {
    label: '',
    note: '',
    errorMessage: '',
    fieldClass: '',
  },
)

const onInput = (event: Event) => {
  model.value = (event.target as HTMLInputElement).value
}

const onBlur = (event: Event) => {
  model.value = (event.target as HTMLInputElement).value.trim()
}
</script>
